var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternBottomDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1085,
    height: 673,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "69.237%",
    x2: "9.399%",
    y2: "32.159%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4389",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512051",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512051",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512051",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355 800c74.356-153.934 215.022-251.268 422-292 310.466-61.099 192.94-122.724 345.47-245.025C1224.157 181.442 1330 136.116 1440 127v673H355z",
    transform: "translate(-355 -127)",
    fill: "url(#a)",
    fillRule: "evenodd",
    opacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternBottomDesktop);
export default __webpack_public_path__ + "static/media/bg-pattern-bottom-desktop.32aa6571dc718836bdfc0e9aeccb9433.svg";
export { ForwardRef as ReactComponent };